import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BungalowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bungalow"}/>
}
